const Error404 = () => {
  return (
    <div className="flex flex-row h-full w-full bg-gray-100">
      <div className="m-auto">
        <div className="flex flex-col bg-gray-100 p-8">
          <div className="text-center mb-8 m-auto">
            <div className="float-left">
              <img
                src="https://badenbower.sgp1.digitaloceanspaces.com/bb-simple-logo.png"
                className="w-9 rounded-full shadow-md"
              />
            </div>
            <div className="text-black font-bold p-1 pl-0 float-left ml-2 text-xl">
              Baden Bower
            </div>
          </div>
          <div>
            <h1 className="font-bold text-2xl">404 - Payment not found</h1>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Error404;
